<template>
  <div>
    <b-card class="attendance">
      <b-row>
        <b-col md="6" class="mb-1 mb-md-0">
          <b-form-group :label="$t('User')">
            <user-search v-model="userId" placeholder="Me" @input="$emit('input', userId)" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group :label="$t('Year')">
            <b-form-select v-model="year" :options="yearRange.map(y => ({ value: y, text: y }))" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <div class="d-flex flex-wrap  align-items-baseline">
      <div class="d-flex col-sm-12 col-md-3 px-0 mr-4 mb-1">
        <div class="bg-success rounded mr-1" style="width: 18px; height:18px" />
        <span>{{ $t('Worked more than an hour') }}</span>
        <b-badge class="ml-2" variant="success">{{ $t(`Total: ${attendanceDetails.validDays}`) }}</b-badge>
      </div>
      <div class="d-flex col-sm-12 col-md-3 px-0 mb-2">
        <div class="bg-warning rounded mr-1" style="width: 18px; height:18px" />
        <span>{{ $t('Worked less than an hour') }}</span>
        <b-badge class="ml-2" variant="warning">{{ $t(`Total: ${attendanceDetails.invalidDays}`) }}</b-badge>
      </div>
    </div>
    <b-row id="tour-attendance">
      <b-col v-for="i in 12" :key="i" md="3">
        <month-blocks :year="year" :month="i" :processing="processing" :present-days="presentDays"
          :present-days-duration="presentDaysDuration" :user-id="userId" :class="{
            'bg-light-success px-2 py-1': i === thisMonth && year === new Date().getFullYear()
          }" />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BCard, BFormSelect, BFormGroup, BBadge } from 'bootstrap-vue'
import UserSearch from '@/views/common/components/UserSearch.vue'
import { getUserData } from '@/auth/utils'
import useApollo from '@/plugins/graphql/useApollo'
import { mapActions, mapGetters } from 'vuex'
import MonthBlocks from './MonthBlocks.vue'
import { setComponentReady } from '../tour/tour'
import _ from 'lodash'
import commonMixin from '@/utils/common'


export default {
  components: {
    MonthBlocks,
    BCard,
    UserSearch,
    BFormSelect,
    BFormGroup,
    BBadge,
  },
  data() {
    const thisYear = (new Date()).getFullYear()
    const yearRange = []
    for (let i = 2022; i <= thisYear; i += 1) {
      yearRange.push(i)
    }
    const defaultUser = getUserData().uuid
    return {
      year: thisYear,
      userId: defaultUser,
      yearRange,
      thisMonth: Number(this.TODAY({ format: 'MM' })),
      presentDays: {},
      presentDaysDuration: {},
      processing: false,
    }
  },
  computed: {
    ...mapGetters('project', ['GET_SELECTED_USER']),

    attendanceDetails() {
      const invalidDays = []
      const validDays = []

      Object.entries(this.presentDaysDuration || {}).forEach(([date, duration]) => {
        if (duration > 3600) {
          validDays.push(date)
        } else invalidDays.push(date)
      })
      return {
        invalidDays: invalidDays.length,
        validDays: validDays.length,
      }
    },
  },
  watch: {
    year: {
      handler() {
        this.getDailyActivityRecords()
      },
      immediate: true,
    },
    userId: {
      handler(newValue) {
        if (newValue) {
          this.getDailyActivityRecords()
          if (this.GET_SELECTED_USER !== newValue) this.setSelectedUser(newValue)
        }
      },
    },
    GET_SELECTED_USER: {
      handler(val) {
        if (val && val !== this.userId) this.userId = val
      },
      immediate: true,
    },
  },
  mounted() {
    setComponentReady()
  },
  methods: {
    ...mapActions('project', ['setSelectedUser']),
    getDailyActivityRecords: _.debounce(function () {
      if (this.processing) return
      this.processing = true
      const startTime = `${this.year}-01-01 00:00:00`
      const endTime = this.ADD_DAYS(`${this.year}-12-31 00:00:00`, 1, 'YYYY-MM-DD 00:00:00').start
      useApollo.activities.getDailyActivities({
        startTime,
        endTime,
        timezone: this.timezone,
        userId: this.userId,
        first: -1,
        timezone: commonMixin.getCompanyTimezoneOffset(),
        projectId: this.$store.state.project.selectedProject,
      }).then(response => {
        const presentDays = {}
        const presentDaysDuration = {}
        const activities = response.data.user?.dailyActivities.data ?? []
        activities.forEach(item => {
          presentDays[item.date] = true
          presentDaysDuration[item.date] = item.duration
        })
        this.presentDays = presentDays
        this.presentDaysDuration = presentDaysDuration
      }).catch(err => {
        console.error(err)
      }).finally(() => { this.processing = false })
    }),
  },
}
</script>

<style lang="scss">
.attendance {
  .vs__selected-options {
    min-height: 35px !important;
  }

  .b-form-datepicker.form-control {
    min-height: 42px !important;
  }
}
</style>
